import { AI_MODELS } from '../chat';
import { ClaudeIconSG, DeepSeekIconSG, GeminiIconSG, KimiIconSG, MistralIconSG, OpenAIIconSG, XAIIconSG, IncognitoIconSG, } from '../components/icons';
export const aiModels = [
    {
        title: 'Incognito',
        subtitle: 'For brief chat (limited context)',
        quality: '1 / 5',
        speed: '5 / 5',
        Icon: IncognitoIconSG,
        value: AI_MODELS.incognito.modelValue,
        isProModel: false,
        isReleased: true,
        aiProviderType: AI_MODELS.incognito.aiProviderType,
        aiProviderName: AI_MODELS.incognito.aiProviderName,
    },
    {
        title: 'GPT-4o Mini',
        subtitle: 'For general purpose',
        quality: '3 / 5',
        speed: '5 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.gpt35Turbo.modelValue,
        isProModel: false,
        isReleased: true,
        aiProviderType: AI_MODELS.gpt35Turbo.aiProviderType,
        aiProviderName: AI_MODELS.gpt35Turbo.aiProviderName,
    },
    {
        title: 'GPT-4o',
        subtitle: 'For complex task',
        quality: '5 / 5',
        speed: '4 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.gpt4O.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.gpt4O.aiProviderType,
        aiProviderName: AI_MODELS.gpt4O.aiProviderName,
    },
    {
        title: 'GPT-4.1 Nano',
        subtitle: 'For general purpose',
        quality: '3 / 5',
        speed: '5 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.gpt41Nano.modelValue,
        isProModel: false,
        isReleased: true,
        aiProviderType: AI_MODELS.gpt41Nano.aiProviderType,
        aiProviderName: AI_MODELS.gpt41Nano.aiProviderName,
    },
    {
        title: 'GPT-4.1 Mini',
        subtitle: 'For general purpose',
        quality: '4 / 5',
        speed: '5 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.gpt41Mini.modelValue,
        isProModel: false,
        isReleased: true,
        aiProviderType: AI_MODELS.gpt41Mini.aiProviderType,
        aiProviderName: AI_MODELS.gpt41Mini.aiProviderName,
    },
    {
        title: 'GPT-4.1',
        subtitle: 'For complex task',
        quality: '5 / 5',
        speed: '5 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.gpt41.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.gpt41.aiProviderType,
        aiProviderName: AI_MODELS.gpt41.aiProviderName,
    },
    {
        title: 'GPT-4o Ghibli',
        subtitle: 'For complex task',
        quality: '5 / 5',
        speed: '4 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.gpt4OGhibli.modelValue,
        isProModel: true,
        isReleased: false,
        aiProviderType: AI_MODELS.gpt4OGhibli.aiProviderType,
        aiProviderName: AI_MODELS.gpt4OGhibli.aiProviderName,
    },
    {
        title: 'GPT-4.5',
        subtitle: 'For complex task',
        quality: '5 / 5',
        speed: '4 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.gpt45.modelValue,
        isProModel: true,
        isReleased: false,
        aiProviderType: AI_MODELS.gpt45.aiProviderType,
        aiProviderName: AI_MODELS.gpt45.aiProviderName,
    },
    {
        title: 'AI Search',
        subtitle: 'For online search',
        quality: '4 / 5',
        speed: '5 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.aiSearch.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.aiSearch.aiProviderType,
        aiProviderName: AI_MODELS.aiSearch.aiProviderName,
    },
    {
        title: 'GPT-o1 Mini',
        subtitle: 'For reasoning',
        quality: '5 / 5',
        speed: '3 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.gptO1Mini.modelValue,
        isProModel: false,
        isReleased: true,
        aiProviderType: AI_MODELS.gptO1Mini.aiProviderType,
        aiProviderName: AI_MODELS.gptO1Mini.aiProviderName,
    },
    {
        title: 'GPT-o1',
        subtitle: 'For reasoning',
        quality: '5 / 5',
        speed: '2 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.gptO1.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.gptO1.aiProviderType,
        aiProviderName: AI_MODELS.gptO1.aiProviderName,
    },
    {
        title: 'GPT-o3 Mini',
        subtitle: 'For STEM reasoning',
        quality: '5 / 5',
        speed: '3 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.O3Mini.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.O3Mini.aiProviderType,
        aiProviderName: AI_MODELS.O3Mini.aiProviderName,
    },
    {
        title: 'GPT-o3',
        subtitle: 'For reasoning',
        quality: '5 / 5',
        speed: '3 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.O3.modelValue,
        isProModel: true,
        isReleased: false,
        aiProviderType: AI_MODELS.O3.aiProviderType,
        aiProviderName: AI_MODELS.O3.aiProviderName,
    },
    {
        title: 'GPT-o4 Mini',
        subtitle: 'For reasoning',
        quality: '5 / 5',
        speed: '3 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.O4Mini.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.O4Mini.aiProviderType,
        aiProviderName: AI_MODELS.O4Mini.aiProviderName,
    },
    {
        title: 'Dall-E 3 SD',
        subtitle: 'For image generation',
        quality: '5 / 5',
        speed: '1 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.dallE3SD.modelValue,
        isProModel: false,
        isReleased: true,
        aiProviderType: AI_MODELS.dallE3SD.aiProviderType,
        aiProviderName: AI_MODELS.dallE3SD.aiProviderName,
    },
    {
        title: 'Dall-E 3 HD',
        subtitle: 'For image generation (High Quality)',
        quality: '5 / 5',
        speed: '1 / 5',
        Icon: OpenAIIconSG,
        value: AI_MODELS.dallE3.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.dallE3.aiProviderType,
        aiProviderName: AI_MODELS.dallE3.aiProviderName,
    },
    {
        title: 'Claude Haiku 3',
        subtitle: 'For general purpose',
        quality: '3 / 5',
        speed: '4 / 5',
        Icon: ClaudeIconSG,
        value: AI_MODELS.claudeHaiku3.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.claudeHaiku3.aiProviderType,
        aiProviderName: AI_MODELS.claudeHaiku3.aiProviderName,
    },
    {
        title: 'Claude Sonnet 3.5',
        subtitle: 'For complex task',
        quality: '5 / 5',
        speed: '3 / 5',
        Icon: ClaudeIconSG,
        value: AI_MODELS.claudeSonnet35.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.claudeSonnet35.aiProviderType,
        aiProviderName: AI_MODELS.claudeSonnet35.aiProviderName,
    },
    {
        title: 'Claude Sonnet 3.5 v2',
        subtitle: 'For complex task',
        quality: '5 / 5',
        speed: '3 / 5',
        Icon: ClaudeIconSG,
        value: AI_MODELS.claudeSonnet35v2.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.claudeSonnet35v2.aiProviderType,
        aiProviderName: AI_MODELS.claudeSonnet35v2.aiProviderName,
    },
    {
        title: 'Claude Sonnet 3.7',
        subtitle: 'For complex task',
        quality: '5 / 5',
        speed: '3 / 5',
        Icon: ClaudeIconSG,
        value: AI_MODELS.claudeSonnet37.modelValue,
        isProModel: true,
        isReleased: false,
        aiProviderType: AI_MODELS.claudeSonnet37.aiProviderType,
        aiProviderName: AI_MODELS.claudeSonnet37.aiProviderName,
    },
    {
        title: 'Grok 2',
        subtitle: 'For general purpose',
        quality: '3 / 5',
        speed: '5 / 5',
        Icon: XAIIconSG,
        value: AI_MODELS.grok2.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.grok2.aiProviderType,
        aiProviderName: AI_MODELS.grok2.aiProviderName,
    },
    {
        title: 'Grok 2 Vision',
        subtitle: 'For general purpose',
        quality: '3 / 5',
        speed: '5 / 5',
        Icon: XAIIconSG,
        value: AI_MODELS.grok2vision.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.grok2vision.aiProviderType,
        aiProviderName: AI_MODELS.grok2vision.aiProviderName,
    },
    {
        title: 'Grok 2 Image',
        subtitle: 'For image generation',
        quality: '5 / 5',
        speed: '3 / 5',
        Icon: XAIIconSG,
        value: AI_MODELS.grok2image.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.grok2image.aiProviderType,
        aiProviderName: AI_MODELS.grok2image.aiProviderName,
    },
    {
        title: 'Grok 3 Mini',
        subtitle: 'For general purpose',
        quality: '4 / 5',
        speed: '5 / 5',
        Icon: XAIIconSG,
        value: AI_MODELS.grok3Mini.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.grok3Mini.aiProviderType,
        aiProviderName: AI_MODELS.grok3Mini.aiProviderName,
    },
    {
        title: 'Grok 3',
        subtitle: 'Smart & Fast / for complex task',
        quality: '5 / 5',
        speed: '5 / 5',
        Icon: XAIIconSG,
        value: AI_MODELS.grok3.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.grok3.aiProviderType,
        aiProviderName: AI_MODELS.grok3.aiProviderName,
    },
    {
        title: 'DeepSeek R1',
        subtitle: 'For reasoning',
        quality: '4 / 5',
        speed: '3 / 5',
        Icon: DeepSeekIconSG,
        value: AI_MODELS.deepseekR1.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.deepseekR1.aiProviderType,
        aiProviderName: AI_MODELS.deepseekR1.aiProviderName,
    },
    {
        title: 'DeepSeek V3',
        subtitle: 'For complex task',
        quality: '3 / 5',
        speed: '4 / 5',
        Icon: DeepSeekIconSG,
        value: AI_MODELS.deepseekV3.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.deepseekV3.aiProviderType,
        aiProviderName: AI_MODELS.deepseekV3.aiProviderName,
    },
    {
        title: 'Kimi',
        subtitle: 'For general purpose (Chinese)',
        quality: '3 / 5',
        speed: '4 / 5',
        Icon: KimiIconSG,
        value: AI_MODELS.kimi.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.kimi.aiProviderType,
        aiProviderName: AI_MODELS.kimi.aiProviderName,
    },
    {
        title: 'Gemini 2.0 Flash-Lite',
        subtitle: 'For general purpose',
        quality: '3 / 5',
        speed: '5 / 5',
        Icon: GeminiIconSG,
        value: AI_MODELS.gemini20FlashLite.modelValue,
        isProModel: false,
        isReleased: true,
        aiProviderType: AI_MODELS.gemini20FlashLite.aiProviderType,
        aiProviderName: AI_MODELS.gemini20FlashLite.aiProviderName,
    },
    {
        title: 'Gemini 2.0 Flash',
        subtitle: 'For complex task',
        quality: '4 / 5',
        speed: '4 / 5',
        Icon: GeminiIconSG,
        value: AI_MODELS.gemini20Flash.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.gemini20Flash.aiProviderType,
        aiProviderName: AI_MODELS.gemini20Flash.aiProviderName,
    },
    {
        title: 'Gemini 2.5 Flash',
        subtitle: 'For reasoning',
        quality: '5 / 5',
        speed: '4 / 5',
        Icon: GeminiIconSG,
        value: AI_MODELS.gemini25Flash.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.gemini25Flash.aiProviderType,
        aiProviderName: AI_MODELS.gemini25Flash.aiProviderName,
    },
    {
        title: 'Gemini 2.5 Pro',
        subtitle: 'For reasoning',
        quality: '5 / 5',
        speed: '3 / 5',
        Icon: GeminiIconSG,
        value: AI_MODELS.gemini25ProExp.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.gemini25ProExp.aiProviderType,
        aiProviderName: AI_MODELS.gemini25ProExp.aiProviderName,
    },
    {
        title: 'Mistral Large',
        subtitle: 'For general purpose',
        quality: '3 / 5',
        speed: '4 / 5',
        Icon: MistralIconSG,
        value: AI_MODELS.mistralLarge.modelValue,
        isProModel: true,
        isReleased: true,
        aiProviderType: AI_MODELS.mistralLarge.aiProviderType,
        aiProviderName: AI_MODELS.mistralLarge.aiProviderName,
    },
];
